import StaticMapSize from './StaticMapSize';

const staticMapScale: Record<StaticMapSize, number> = {
  '1280x582': 2,
  '512x217': 1,
  '128x128': 2,
  '160x160': 2,
  '200x200': 2,
  '295x240': 2,
  '320x320': 2,
  '327x218': 2,
  '342x424': 2,
  '368x182': 2,
  '368x372': 2
};

export const getStaticMapScale = (size: StaticMapSize): number => staticMapScale[size];
